import { stitch } from 'keo';
import Mail from 'material-ui/svg-icons/content/drafts';
import PropTypes from 'prop-types';
import r from 'render-dom';

import { resetPassword } from 'redux/auth/actions';

import PasswordReset from './PasswordReset';

const propTypes = {
    hasResetPassword: PropTypes.bool.isRequired,
    history: PropTypes.object.isRequired,
    postReset: PropTypes.func.isRequired,
    resetCode: PropTypes.string,
};

const render = ({ props: { hasResetPassword, history, postReset, resetCode } }) => {
    const onSubmit = (values) => {
        return postReset({ ...values.toJS(), resetCode }).then(() => {
            if (resetCode) {
                return history.push('/');
            }

            return null;
        });
    };

    return (
        r.div([
            r(PasswordReset, {
                history,
                isRendered: !hasResetPassword,
                onSubmit,
                resetCode,
            }),
            r.div({
                isRendered: hasResetPassword && !resetCode,
                style: { color: '#888', padding: '20px 0', textAlign: 'center' }
            }, [
                r(Mail, { color: '#888', style: { height: 55, width: 55 } }),
                r.h2({ style: { marginTop: 0 } }, [
                    'Check Your Email',
                ]),
                r.div([
                    `We just sent you an email. Just follow the link to set your new
                    password.`
                ]),
            ])
        ])
    );
};

export default stitch(
    { propTypes, render },
    ({ auth }) => ({ hasResetPassword: auth.get('hasResetPassword', false) }),
    { postReset: resetPassword }
);



// WEBPACK FOOTER //
// ./src/components/shared/PasswordReset/index.js